import React, {Component} from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import Visibility from 'visibilityjs';
import {withRouter} from 'react-router-dom';

import {getQuery} from './request';

const getPath = location => {
  const query = getQuery(location);

  return `${location.pathname}${query ? `?${query}` : ''}`;
};

ReactGA.initialize([
  {
    trackingId: 'UA-58716663-11'
  },
  {
    gaOptions: {name: 'pageview'},
    trackingId: 'UA-58716663-12' // 'page-view only'
  },
  {
    gaOptions: {name: 'events'},
    trackingId: 'UA-58716663-13'
  },
  {
    gaOptions: {name: 'errors'},
    trackingId: 'UA-58716663-14'
  }
]);

const withGA = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    ReactGA.set({
      page,
      ...options
    });

    ReactGA.pageview(page, ['pageview']);
  };

  return withRouter(
    class WithGA extends Component {
      static propTypes = {
        location: PropTypes.object.isRequired
      };

      trackInitialPage = () => {
        const {location} = this.props;

        if (!this._isTracked) {
          trackPage(getPath(location));

          this._isTracked = true;
        }
      };

      componentDidMount() {
        this._isTracked = false;

        Visibility.onVisible(() => {
          this.trackInitialPage();
        });

        document.addEventListener('bridge-ready', () => {
          window.snaptube.listenUI('report.screenview', false, () => {
            this.trackInitialPage();
          });
        });
      }

      componentWillReceiveProps({location}) {
        if (location.pathname !== this.props.location.pathname) {
          trackPage(getPath(location));
        }
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    }
  );
};

export default withGA;



// WEBPACK FOOTER //
// ./components/withGA.js